<template>
  <div class="flex flex-wrap">
    <div class="starboat" v-for='(pic,index) in boatitems' :Key='index' @click='gotosteamerTicket(pic.id,pic.name,pic.img)'>
      <img :src='pic.img' alt="">
      <p class='name'>{{pic.name}}({{pic.capacity}}人)</p>
      <p class='descript'>{{pic.detail}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    boatitems: {
      default: () => {
        return []
      },
      type: Array,
      required: true
    }
  },
  methods: {
    gotosteamerTicket (id, name, img) {
      this.$router.push({
        path: '/steamerTicket',
        query: {
          id: id,
          name: name,
          img: img
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
   .flex{
    display:flex;
  }
 .flex-wrap{
    flex-wrap:wrap;
  }
 .starboat {
   cursor: pointer;
    width:18.125rem;
    border:1px solid #e8e8e8;
    padding-bottom:1.25rem;
    margin-right:20px;
    &:hover {
        box-shadow: 0px 0px 12px #ccc9c9;
        transition: all 0.2s;
        transform: scale(1.02);
    }
  }
  .starboat:nth-of-type(4n+4){
    margin-right:0;
  }
  .starboat img{
    width:100%;
    height:16.625rem;
  }
  .starboat .name{
    font-size:18px;
    color:#434343;
    margin-top:20px;
    margin-left:20px;
  }
  .starboat .descript{
    font-size: 14px;
    color:#7a7a7a;
    margin-top:10px;
    margin-left:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/boat/boat.vue